<template>
  <div>
    <BaseListPage
        :name="name"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="_tableSetList"
        :table-data-list="sortedList"
        :conditions="conditions"
        :min-column-width="'110px'"
        :show-pagination="true"
        :is-max-get-count="false"
        :async-render="true"
        :max-get-count="isMaxGetCount"
        :cell-style="cellStyle"
        title="決済ログ：コンビニ決済"
        title-class="payment-header"
        icon="report"
        @row-click="onRowClick">
      <template slot="prefixTable">
        <div class="prefixTableRow">
          <el-button size="small"
              @click="clickDisplaySelect">
            表示項目
          </el-button>
        </div>
      </template>
    </BaseListPage>
    <!-- 表示項目 -->
    <BaseDisplaySelectModal
        function-key="payment_convenience_list"
        :table-set-list="_tableSetList"
        :display-config="displayItems"
        :store-path="storePath"
        :visible.sync="isDisplaySelectDialog" />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/payment'
import x from '@/components/mixins/mixin'
import common from '@/utils/common'
import orderUtil from '@/components/mixins/orderUtil'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import BaseDisplaySelectModal from '@/components/organisms/BaseDisplaySelectModal'

export default {
  name: 'PaymentConvenienceList',
  components: {
    BaseListPage,
    BaseDisplaySelectModal
  },
  mixins: [ x, orderUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isDisplaySelectDialog: false,
      showSelection: false,
      showActionList: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      tableSetList: (state) => state.PaymentConvenience.tableSetList || false,
      searchKeyword: (state) => state.PaymentConvenience.searchKeyword || '',
      isAndSearch: (state) => state.PaymentConvenience.isAndSearch || false,
      conditions: (state) => state.PaymentConvenience.searchConditions || {},
      tdLists: (state) => state.PaymentConvenience.tdLists || [],
      timeZone: (state) => state.timeZone || 'Asia/Tokyo',
      displayItems: (state) => state.PaymentConvenience.displayItems || []
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions',
      customCellStyle: 'customCellStyle'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'PaymentConvenienceList'
    },
    storePath () {
      return 'PaymentConvenience'
    },
    saveKey () {
      return 'paymentConvenienceCondition'
    },
    responsePath () {
      return 'data.paymentLists.edges'
    },
    linkKey () {
      return ['node.site_code', 'node.orderNo']
    },
    returnPath () {
      return '/report/payment/convenience'
    },
    baseQuery () {
      return 'query { ' + query.GRAPH_QL_QUERY_PAYMENT_CVS +
       query.GRAPH_QL_QUERY_PAYMENT_LIST +
       '}}'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      const returnValue = [
        {
          itemKey: 'orderStatus', isAvailable: true, isActive: true, width: 130,
          type: 'String', label: '注文ステータス', elementType: ELEMENT_TYPE.TAG,
          path: this.orderStatus, class: 'center order-status-tag', size: 'small',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.ORDER_STATUS
        },
        {
          itemKey: 'process_code', isAvailable: false, isActive: false, width: 130,
          type: 'String', label: '支払処理タイプ', elementType: ELEMENT_TYPE.FUNCTION,
          path: this.processCode, class: 'center', size: 'small',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.PAYMENT_CODE
        },
        {
          itemKey: 'status_code', isAvailable: false, isActive: false, width: 150,
          type: 'String', label: '支払処理ステータス', elementType: ELEMENT_TYPE.FUNCTION,
          path: this.statusCode, class: 'center', size: 'small',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.PAYMENT_STATUS
        },
        {
          itemKey: 'orderNo', isAvailable: false, isActive: false, width: 160,
          type: 'String', label: '注文番号', path: 'node.orderNo', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.ORDER_NO
        },
        {
          itemKey: 'customerNo', isAvailable: false, isActive: false, width: 150,
          type: 'String', label: '顧客番号', sortable: 'custom',
          elementType: ELEMENT_TYPE.LINK, path: 'node.customerNo',
          class: 'innerItem', linkKey: 'node.uuid', linkPath: '/customer/',
          onLinkClick: (key, keyPath) => { this.$_mixin_onLinkClick(-1, 'Customer') },
          funcId: define.PermissionKeys.Report.Payment.Payment_list.CUSTOMER_NO
        },
        {
          itemKey: 'transactionId', isAvailable: false, isActive: false, width: 150,
          type: 'String', label: 'SLN処理通番', path: 'node.transactionId', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.TRANSACTION_ID
        },
        {
          itemKey: 'response_code', isAvailable: false, isActive: false, width: 180,
          type: 'String', label: 'SLN処理結果コード', path: 'node.response_code', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.RESPONSE_CODE
        },
        {
          itemKey: 'transaction_id_1', isAvailable: false, isActive: false, width: 160,
          type: 'String', label: 'SLNプロセスID', path: 'node.transaction_id_1', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.SLN_PROSESS_ID
        },
        {
          itemKey: 'kessaiNumber', isAvailable: false, isActive: false, width: 130,
          type: 'String', label: 'SLN決済番号', path: 'node.kessaiNumber', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.KESSAI_NUMBER
        },
        {
          itemKey: 'amount', isAvailable: false, isActive: false, class: 'right',
          type: 'String', label: '支払額', path: 'node.amount', sortable: true, sortBy: (row) => {
            return Number(row.node.amount)
          },
          funcId: define.PermissionKeys.Report.Payment.Payment_list.AMOUNT
        },
        {
          itemKey: 'order_datetime', isAvailable: false, isActive: false,
          type: 'Datetime', label: '注文日時', path: 'node.orderDatetime', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.ORDER_DATETIME
        },
        {
          itemKey: 'created_at', isAvailable: false, isActive: false,
          type: 'Datetime', label: '登録日時', path: 'node.createdAt', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.CREATED_AT
        },
        {
          itemKey: 'canseled_at', isAvailable: false, isActive: false, width: 180,
          type: 'Datetime', label: 'キャンセル日時', path: 'node.canseled_at', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.CANSELED_AT
        },
        {
          itemKey: 'payLimit', isAvailable: false, isActive: false, width: 130,
          type: 'Datetime', label: '支払い期限', path: 'node.payLimit', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.PAY_LIMIT
        },
        {
          itemKey: 'processed_at', isAvailable: false, isActive: false, width: 150,
          type: 'Datetime', label: '入金通知日時', path: 'node.processed_at', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.PROCESSED_AT
        },
        {
          itemKey: 'paid_at', isAvailable: false, isActive: false, width: 130,
          type: 'Datetime', label: '入金日時', path: 'node.paid_at', sortable: 'custom',
          funcId: define.PermissionKeys.Report.Payment.Payment_list.PAID_AT
        }
      ]

      for (const displayItem of (this.displayItems || []).filter((data) => !data.isAttribute)) {
        const item = returnValue.find((data) => data.itemKey === displayItem.itemKey)
        if (item) {
          _.set(item, 'isAvailable', true)
          _.set(item, 'isActive', displayItem.isDisplay)
          _.set(item, 'displayOrder', displayItem.displayOrder)
        }
      }

      return returnValue.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)
    },
    showProductUnit () {
      return this._tableSetList.some((item) => item.isProductUnit && item.isActive && item.isAvailable)
    },
    isMaxGetCount () {
      return this.maxGetCount(this.storePath)
    }
  },
  watch: {
    displayItems: {
      handler: function (val) {
        this.$store.dispatch({
          type: 'set',
          states: {
            'PaymentConvenience/tableSetList': this._tableSetList
          }
        })
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // ダウンロードが可能のとき、アクションを表示
      const tempThisComponent = this
      setTimeout(() => {
        tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
      }, 1)

      // 設定tableSetListの情報取得
      const work = await common.getDisplayItems('payment_convenience_list')

      this.$store.dispatch({
        type: 'set',
        states: {
          'PaymentConvenience/displayItems': work
        }
      })

      this.$store.dispatch({
        type: 'set',
        states: {
          'PaymentConvenience/tableSetList': this._tableSetList
        }
      })
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    /**
     * 注文ステータスを返却します。
     * @param {Object} row 注文情報
     * @returns {Array} tag 生成のための配列
     */
    orderStatus: function (row) {
      row.node.isShipment = 1
      return this.$_orderUtil_orderStatusTag(row.node)
    },
    onRowClick (row, column, event) {
      const id = this.$_mixin_getData(row, this.linkKey, '&')
      const index = this.findIndex(row)
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/order/${id}` })
    },
    findIndex (row) {
      let condition = _.chain(this.linkKey)
        .reduce((acc, cur) => {
          acc[cur] = _.get(row, cur)
          return acc
        }, {})
        .value()
      return this.$_mixin_findIndex(this.sortedList, condition)
    },
    // 表示項目のクリック動作？
    clickDisplaySelect () {
      this.isDisplaySelectDialog = true
    },
    processCode: function (row) {
      const processCode = _.get(this.getServiceSiteConfig(
        '', define.SERVICESITECONFIG_KEYS.PROCESS_CODE.key1,
        define.SERVICESITECONFIG_KEYS.PROCESS_CODE.key2,
        row.node.process_code), 'label')
      return processCode
    },
    statusCode: function (row) {
      const statusCode = _.get(this.getServiceSiteConfig(
        '', define.SERVICESITECONFIG_KEYS.STATUS_CODE.key1,
        define.SERVICESITECONFIG_KEYS.STATUS_CODE.key2,
        row.node.status_code), 'label')
      return statusCode
    },
    cellStyle (r) {
      return this.$_mixin_cellStyle(r, this.customCellStyle('payment_convenience_list'), 'node.')
    },
    maxGetCount: function (path) {
      this.$store.dispatch({
        type: 'set',
        states: { [path + '/maxGetCount']: 2000 }
      })
    }
  }
}
</script>

<style scoped>
  .prefixTableRow .el-button {
    text-align: center;
    margin-bottom: 10px;
  }
  .prefixTableRow .el-button ::v-deep span {
    margin: 0px;
  }
  .base-list-page ::v-deep .description .cell .inner-cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
</style>
